import { RootState } from "store/store";

export const colorPickerSelector = (state: RootState) => state.colorPicker;
